// extracted by mini-css-extract-plugin
export default {"login__container":"styles_login__container__n0fJ4","login__links":"styles_login__links__yAq6C"};